import { combineReducers } from 'redux';
import { combineEpics } from 'redux-observable';
import auth, { authEpic } from './auth';
import { misc } from './misc';
import { subscribe } from './subscribe';


export const rootReducer = combineReducers({ auth, subscribe, misc });
export const rootEpic = combineEpics(authEpic);

export type Store = ReturnType<typeof rootReducer>;
